import { Drawer, Modal } from "antd";
import { FC, useEffect } from "react";
import { useParams } from "react-router-dom";

import { useLoc } from "@app/shared/lib/hooks";
import { useDevice } from "@app/shared/providers/DeviceProvider";

import { useUIAppState } from "../../UIAppStateProvider";
import { StudentProfileForm } from "../StudentProfileForm/StudentProfileForm";

export const StudentProfileModal: FC = () => {
  const loc = useLoc();

  const UIAppState = useUIAppState();
  const { deviceSize } = useDevice();

  const { notifications } = useParams<{ notifications?: string }>();

  useEffect(() => {
    if (!notifications) return;
    UIAppState.setIsProfileDrawerVisible(true, "notifications");
  }, [UIAppState, notifications]);

  const form = (
    <StudentProfileForm
      viewMode="default"
      defaultTab={UIAppState.defaultProfileTab}
      onSave={() => UIAppState.setIsProfileDrawerVisible(false)}
    />
  );
  const close = () => UIAppState.setIsProfileDrawerVisible(false);

  // phones: a full-height sheet instead of a centred dialog
  if (deviceSize === "mobile")
    return (
      <Drawer
        open={UIAppState.isProfileDrawerVisible}
        title={loc.word("User profile")}
        placement="bottom"
        size="94%"
        destroyOnHidden
        onClose={close}
        rootClassName="student-profile-sheet"
      >
        {form}
      </Drawer>
    );

  return (
    <Modal
      open={UIAppState.isProfileDrawerVisible}
      title={loc.word("User profile")}
      width={720}
      destroyOnHidden
      onCancel={close}
      footer={null}
      className="p-0"
    >
      {form}
    </Modal>
  );
};
